import { render, staticRenderFns } from "./Automacao.vue?vue&type=template&id=18ad92b7&scoped=true&"
import script from "./Automacao.vue?vue&type=script&lang=js&"
export * from "./Automacao.vue?vue&type=script&lang=js&"
import style0 from "./Automacao.vue?vue&type=style&index=0&id=18ad92b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ad92b7",
  null
  
)

export default component.exports